import React from "react";
import { ArrowLeft } from "lucide-react";
import "../pages/login.css";

const CONTENT = {
  privacy: {
    title: "Informativa sulla privacy",
    intro: "ingego è il gestionale usato dallo studio tecnico per organizzare pratiche, cantieri, scadenze e documenti. Questa pagina riassume come vengono trattati i dati inseriti nella piattaforma.",
    sections: [
      ["Titolare del trattamento", "Il titolare è lo studio professionale che utilizza ingego e che ha inserito i dati nella piattaforma. Per ogni richiesta puoi rivolgerti direttamente allo studio."],
      ["Dati trattati", "Dati identificativi e di contatto di clienti e collaboratori, dati relativi a pratiche edilizie, cantieri, documenti tecnici e importi concordati, oltre ai dati di accesso (email, credenziali cifrate, registro delle operazioni)."],
      ["Finalità e base giuridica", "I dati sono trattati per l'esecuzione dell'incarico professionale, per adempimenti di legge in materia di edilizia e sicurezza e per la gestione amministrativa dello studio."],
      ["Conservazione e sicurezza", "I dati sono conservati per il tempo necessario agli obblighi professionali e fiscali. Le password sono salvate con algoritmi di hashing, gli accessi sono tracciati e i documenti sono archiviati su storage cifrato."],
      ["Diritti dell'interessato", "Puoi chiedere accesso, rettifica, cancellazione, limitazione e portabilità dei dati scrivendo allo studio che gestisce il tuo fascicolo."],
    ],
  },
  termini: {
    title: "Termini di servizio",
    intro: "L'uso di ingego è riservato agli utenti autorizzati dallo studio. Accedendo alla piattaforma accetti le condizioni riportate di seguito.",
    sections: [
      ["Accesso e credenziali", "Ogni account è personale. Le credenziali non vanno condivise e ogni utilizzo effettuato con le tue credenziali è considerato tuo. Segnala subito allo studio eventuali accessi non autorizzati."],
      ["Uso consentito", "La piattaforma va usata esclusivamente per l'attività professionale dello studio. È vietato estrarre o diffondere dati di clienti e cantieri per finalità diverse."],
      ["Documenti generati", "I documenti prodotti (verbali, lettere, preventivi, dichiarazioni) sono modelli di supporto: la verifica dei contenuti e la responsabilità professionale restano in capo al tecnico che li firma."],
      ["Disponibilità del servizio", "Lo studio si impegna a mantenere il servizio disponibile, senza garantire la continuità assoluta in caso di manutenzioni o cause esterne."],
      ["Modifiche", "Le condizioni possono essere aggiornate: la versione in vigore è sempre quella pubblicata in questa pagina."],
    ],
  },
  supporto: {
    title: "Supporto",
    intro: "Hai bisogno di aiuto con ingego? Ecco come ricevere assistenza nel modo più rapido.",
    sections: [
      ["Problemi di accesso", "Se hai dimenticato la password, l'amministratore dello studio può reimpostarla da Impostazioni → Utenti e ruoli. Con l'accesso Google usa lo stesso indirizzo email registrato nello studio."],
      ["Segnalare un problema", "Indica la pagina in cui si è verificato il problema, l'operazione che stavi svolgendo e, se possibile, uno screenshot: velocizza di molto la risoluzione."],
      ["Richieste di modifica", "Nuovi modelli di documento, nuove voci di catalogo o nuovi automatismi si configurano dalla sezione Impostazioni. Per esigenze diverse scrivi allo studio."],
      ["Contatti", "Scrivi all'amministratore dello studio che ti ha creato l'accesso: trovi il suo indirizzo nella sezione Utenti e ruoli del gestionale."],
    ],
  },
};

export default function LegalPage({ page }) {
  const data = CONTENT[page] || CONTENT.supporto;
  return <main className="legal-page" data-testid={`legal-page-${page}`}>
    <img src="/brand/ingego-logo.png" alt="ingego" />
    <h1>{data.title}</h1>
    <p>{data.intro}</p>
    {data.sections.map(([heading, text]) => <section key={heading}>
      <h2>{heading}</h2>
      <p>{text}</p>
    </section>)}
    <a className="legal-back" href="/" data-testid="legal-back"><ArrowLeft size={15} />Torna all'accesso</a>
  </main>;
}
